export default () => ({
    init() {
        const backToTopBtn =  document.querySelector('.back-to-top')
        window.addEventListener("scroll", () => {
              if (window.pageYOffset > screen.height ) {
                 backToTopBtn.classList.remove('hidden-btn');
              } else 
              {
                backToTopBtn.classList.add('hidden-btn');
              }
          })
    }
})